export default class Submission {
    constructor({
        id = null,
        student_id = null,
        subtask_id = null,
        submission_date = '',
        precheck_successfull = null,
        precheck_log_file_path = '',
        container_log_path = '',
        container_error = '',
        file_paths = []
    }) {
        this.id = id;
        this.student_id = student_id;
        this.subtask_id = subtask_id;
        this.submission_date = submission_date;
        this.precheck_successfull = precheck_successfull;
        this.precheck_log_file_path = precheck_log_file_path;
        this.container_log_path = container_log_path;
        this.container_error = container_error;
        this.file_paths = file_paths;
    }

    // Basic validation for submission data
    static validate(submissionData) {
        if (!submissionData.student_id) {
            throw new Error('Student ID is required');
        }
        if (!submissionData.subtask_id) {
            throw new Error('Subtask ID is required');
        }
    }

    // Format date to DD.MM.YYYY HH:MM:SS
    static formatDate(date) {
        if (typeof date !== 'string') {
            if (date instanceof Date && !isNaN(date)) {
                date = date.toISOString();
            } else {
                try {
                    date = new Date(date).toISOString();
                } catch (e) {
                    console.error('Invalid date:', date);
                    return '';
                }
            }
        }
        if (!date) return '';

        const [datePart, timePart] = date.split('T');
        const [year, month, day] = datePart.split('-');
        const [hour, minute, second] = timePart.split(':').map(part => part.split('.')[0]);

        return `${day}.${month}.${year} ${hour}:${minute}:${second}`;
    }

    static formatDateForInput(date) {
        return date ? date.split('T')[0] : '';
      }
}